import { AxiosError } from 'axios';
import { ServerResponse, WithAuditDetails } from 'data/types';
import { History } from 'history';
import { Dispatch, Action } from 'redux';
import i18n from 'i18n';
import { showSuccessMessage, showError } from 'shared/toaster';
import { ThunkDispatch } from 'redux-thunk';
import { RootState } from 'data/root.reducers';
import { extractErrorMessage } from '../../utils';
import * as api from './radiusParserPassword.api';
import {
  GET_RADIUS_PARSER_PASSWORD,
  UPDATE_RADIUS_PARSER_PASSWORD,
  DELETE_RADIUS_PARSER_PASSWORD,
  GO_TO_RADIUS_PARSER_PASSWORD_EDIT,
  GO_TO_RADIUS_PARSER_PASSWORD_VIEW,
  GO_TO_RADIUS_PARSER_PASSWORD_CREATE,
  SET_RADIUS_PARSER_PASSWORD_LOADING,
  CREATE_RADIUS_PARSER_PASSWORD,
  UpdateRadiusParserPasswordThunkAction,
  DeleteRadiusParserPasswordThunkAction,
  SetRadiusParserPasswordLoadingAction,
  RadiusParserPasswordActionTypes,
  RadiusParserPassword,
  CreateRadiusParserPasswordThunkAction,
} from './radiusParserPassword.types';
import { RADIUS_PARSER_PASSWORD, NETWORK, SYSTEM_CONFIGURATION_ROUTE } from '../../constants';

export function goToRadiusParserPasswordCreate(history: History): (dispatch: Dispatch) => void {
  return (dispatch: Dispatch) => {
    dispatch({
      type: GO_TO_RADIUS_PARSER_PASSWORD_CREATE,
    });

    history.push(`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${RADIUS_PARSER_PASSWORD}`);
  };
}

export function goToRadiusParserPasswordEdit(history: History): (dispatch: Dispatch) => void {
  return (dispatch: Dispatch) => {
    dispatch({
      type: GO_TO_RADIUS_PARSER_PASSWORD_EDIT,
    });

    history.push(`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${RADIUS_PARSER_PASSWORD}/edit`);
  };
}

export function goToRadiusParserPasswordView(history: History): (dispatch: Dispatch) => void {
  return (dispatch: Dispatch) => {
    dispatch({
      type: GO_TO_RADIUS_PARSER_PASSWORD_VIEW,
    });

    history.push(`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${RADIUS_PARSER_PASSWORD}/view`);
  };
}

export function setRadiusParserPasswordLoadingAction(
  isLoading: boolean,
): SetRadiusParserPasswordLoadingAction {
  return {
    type: SET_RADIUS_PARSER_PASSWORD_LOADING,
    payload: { isLoading },
  };
}

export function getRadiusParserPassword(): RadiusParserPasswordActionTypes {
  return {
    type: GET_RADIUS_PARSER_PASSWORD,
    payload: api.getRadiusParserPassword(),
  };
}

export function createRadiusParserPassword(
  body: WithAuditDetails<RadiusParserPassword>,
  history: History,
): CreateRadiusParserPasswordThunkAction {
  return async (dispatch: ThunkDispatch<RootState, unknown, Action<string>>) => {
    try {
      await dispatch({
        type: CREATE_RADIUS_PARSER_PASSWORD,
        payload: api.createRadiusParserPassword(body),
      });

      dispatch(goToRadiusParserPasswordView(history));

      showSuccessMessage(i18n.t('radiusParserPassword.create.success'), 5000);
    } catch (e) {
      const errorMessage = extractErrorMessage(e as AxiosError<ServerResponse<void>>);
      showError(i18n.t('radiusParserPassword.create.failed', { error: errorMessage }));
    }
  };
}

export function updateRadiusParserPassword(
  id: string,
  body: WithAuditDetails<RadiusParserPassword>,
  history: History,
): UpdateRadiusParserPasswordThunkAction {
  return async (dispatch: ThunkDispatch<RootState, unknown, Action<string>>) => {
    try {
       await dispatch({
        type: UPDATE_RADIUS_PARSER_PASSWORD,
        payload: api.updateRadiusParserPassword(id, body),
      });

      dispatch(goToRadiusParserPasswordView(history));
      showSuccessMessage(i18n.t('radiusParserPassword.update.success', { name: body.data.usage }), 5000);

    } catch (e) {
      const errorMessage = extractErrorMessage(e as AxiosError<ServerResponse<void>>);
      showError(i18n.t('radiusParserPassword.update.failed', { error: errorMessage }));
    }
  };
}

export function deleteRadiusParserPassword(
  id: string,
  body: WithAuditDetails<void>,
  history: History,
): DeleteRadiusParserPasswordThunkAction {
  return async (dispatch: ThunkDispatch<RootState, unknown, Action<string>>, getState: () => RootState) => {

    try {
      await dispatch({
        type: DELETE_RADIUS_PARSER_PASSWORD,
        payload: api.deleteRadiusParserPassword(id, body),
      });

      dispatch(goToRadiusParserPasswordCreate(history));
      showSuccessMessage(i18n.t('radiusParserPassword.delete.success'));

    } catch (e) {
      const errorMessage = extractErrorMessage(e as AxiosError<ServerResponse<void>>);
      showError(i18n.t('radiusParserPassword.delete.failed', { error: errorMessage }));
    }
  };
}
